<!-- 课程视频 -->
<template>
  <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="700px" top="200px" @close="handleClose"
             :close-on-click-modal="false"

             append-to-body>

    <div class="tc-main">
      <div class="tabs">
        <el-steps :active="activeName" finish-status="success" simple>
          <el-step :title="item.label" v-for="(item, index) in tabList" :key="index"></el-step>


        </el-steps>
        <!-- <div class="tabs__item" v-for="(item, index) in tabList" :key="index" @click="changeTab(item.value)" :style="{
            'border-bottom': activeName == item.value ? '1px solid #12618A' : 'none',
        }">
            <span>
                {{ item.label }}
            </span>
        </div> -->

      </div>
      <div class="content">

        <div v-show="activeName == 0">
          <el-form :disabled="disabled" label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm1"
                   label-width="100px" class="demo-ruleForm">
            <el-form-item label="选择大纲：" prop="contents_id">
              <el-cascader v-model="ruleForm.contents_id" :options="options" style="width: 100%;"
                           :props="{
                                checkStrictly: true,
                                label: 'contents_name',
                                value: 'contents_id',
                                children: 'children'
                            }" clearable></el-cascader>
            </el-form-item>

            <el-form-item label="名称" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="课程简介" prop="intro">
              <el-input type="textarea" placeholder="请输入课程视频简要介绍..." v-model="ruleForm.intro" maxlength="200"
                        show-word-limit rows="4">
              </el-input>
            </el-form-item>
            <div class="box">
              <el-form-item label="价格：" prop="price" label-width="100px" style="width: 250px">
                <el-input placeholder="最大10000" v-model.number="ruleForm.price" :min="0" :max="10000"
                          type="number">
                  <template slot="append">
                    <p class="color_red">元</p>

                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="AI学分：" prop="credits" label-width="80px" style="width: 230px">
                <el-input placeholder="请输入" v-model.number="ruleForm.credits" :min="0" :max="100"
                          type="number">

                  <template slot="append">
                    <p class="color_primary">学分</p>
                  </template>
                </el-input>
              </el-form-item>
              <span class="color_red margin_left_10">
                                (可分配学分：{{ allocableCredits }}分)
                            </span>

            </div>

          </el-form>
        </div>
        <div class="box2" v-show="activeName == 1">
          <el-form :disabled="disabled" label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm2"
                   label-width="100px" class="form2 demo-ruleForm">
            <el-form-item prop="cover" class="courseImage" style="margin:0">
              <span class="required">*</span>
              <el-upload action="#" class="avatar-uploader courseImageUpload" :show-file-list="false"
                         :disabled="disabled" :before-upload="beforeUpload">
                <img v-if="ruleForm.cover" :src="$imgUrl(ruleForm.cover) + `?t=${Date.now()}`"
                     class="avatar">

                <template v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <span>视频封面</span>
                </template>

              </el-upload>
            </el-form-item>
            <div class="video_box">
              <el-upload :disabled="disabled" class="upload-demo" action="#" :show-file-list="false"
                         :http-request="uploadFn1" :before-upload="beforeUpload1">
                <div>

                  <span>只能上传视频格式:avi,mp4,mov,mkv文件 &nbsp;</span>
                  <el-button size="small" type="primary">点击上传</el-button>

                </div>
              </el-upload>
              <!-- 新增进度条显示区域 -->
              <div v-show="showProgress" class="upload-progress">
                <el-progress :percentage="progress"></el-progress>
              </div>
              <el-form-item style="margin:0" :label-width="'0px'">
                <div style="height:100px">
                  <div class="videoList" v-for="(item, index) in fileList" :key="index">
                    <i class="el-icon-document"></i>
                    <p class="text_ellipsis pointer" @click="previewVideo($imgUrl(item.path))">{{
                        item.path
                      }}
                    </p>
                    <i style="color:#72C648;" class="el-icon-circle-check"></i>
                  </div>
                </div>
              </el-form-item>
            </div>

          </el-form>
        </div>

      </div>
    </div>

    <!-- v-if  从新渲染 -->
    <span slot="footer" class="dialog-footer">
            <template v-if="!disabled">
                <template v-if="activeName == 0">
                    <el-button type="primary" @click="handleOk">下 一 步</el-button>
                </template>
                <template v-else>
                    <el-button @click="activeName = 0">上 一 步</el-button>
                    <el-button type="primary" @click="handleOk">确 定</el-button>
                </template>
                <el-button @click="cancel">取 消</el-button>
            </template>
            <template v-else>
                <el-button @click="activeName = 1" v-if="activeName == 0">下 一 步</el-button>
                <el-button type="primary" @click="activeName = 0" v-else>上 一 步</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </template>
        </span>
    <previewVideo ref="previewVideo"></previewVideo>
    <el-dialog v-dialogDrag title="裁切课程封面" :visible.sync="cropperModel.val" width='1100px' top="200px" :modal="false"
               :append-to-body="true" v-if="cropperModel.val">
      <v-vuecropper :cropperModel="cropperModel" :imgFile="vuecropper_file" :imgW="300" :imgH="185"
                    v-on:upload="uploadFn"></v-vuecropper>
    </el-dialog>
  </el-dialog>
</template>

<script>
import previewVideo from './previewVideo.vue'
import vuecropper from "@/components/commonComponents/vueCropper.vue";

export default {
  props: {
    videoInfo: {
      type: Object,
    }
  },
  components: {

    previewVideo,
    "v-vuecropper": vuecropper,

  },
  data() {

    return {
      dialogVisible: false,
      // 裁剪
      edit: false,

      cropperModel: {val: false},
      vuecropper_file: '',
      // 裁剪
      disabled: false,
      title: '添加课程视频',
      options: [],
      accept: ["video/avi", "video/mp4", "video/mov", "video/mkv"],
      tabList: [
        {
          label: '视频简介',
          value: '0'
        },
        {
          label: '上传视频',
          value: '1'
        },
      ],
      activeName: 0,
      allocableCredits: null,
      ruleForm: {
        "outline_name": "",
        id: '',//	视频课程 ID
        name: '',//	视频课程名称
        intro: '',//	课程介绍
        outline_id: '',//	主课程详情 ID
        contents_id: '',//	课程大纲目录 ID
        enterprise_id: '',//	企业 id
        enterprise_name: '',//	企业名称
        price: null,//	float64	价格
        credits: null,//	int	学分
        file_name: '',//	文件名称
        cover: '',//	封面
      },
      fileList: [],
      progress: 0,       // 上传进度百分比
      showProgress: false,// 是否显示进度条
      rules: {
        contents_id: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入视频课程名称', trigger: 'blur'},

        ],
        price: [
          {required: true, message: '请输入价格', trigger: 'blur'},
          {type: 'number', min: 0, max: 10000, message: '价格必须在0-10000元之间', trigger: 'blur'}  // 新增范围验证
        ],
        credits: [
          {required: true, message: '请输入AI学分', trigger: 'blur'},
          {type: 'number', min: 0, max: 100, message: '学分必须在0-100分之间', trigger: 'blur'}  // 新增范围验证
        ],
        cover: [
          {required: true, message: '请上传封面',},
        ]

      }
    }
  },
  methods: {
    init(data, edit) {
      this.edit = edit

      this.disabled = false
      this.activeName = 0
      if (edit) {//编辑，不需要调接口直接回显

        this.fileList = data.file_name ? [{
          path: data.file_name,
        }] : [];
        this.ruleForm = data
      } else {//新增
        this.fileList = []
        this.ruleForm = {
          "outline_name": "",

          id: '',//	视频课程 ID
          name: '',//	视频课程名称
          intro: '',//	课程介绍
          outline_id: data.outline_id,//	主课程详情 ID
          contents_id: [],//	课程大纲目录 ID
          enterprise_id: data.enterprise_id,//	企业 id
          enterprise_name: data.enterprise_name,//	企业名称
          price: null,//	float64	价格
          credits: null,//	int	学分
          file_name: '',//	文件名称
          cover: '',//	封面
        }
      }


      this.getOptions()
      this.trainingCoursegetRemainingScore(data.outline_id)
    },
    getOptions() {


      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.trainingOutlineTree, {
                data: {
                  outline_id: this.ruleForm.outline_id
                }
              }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data && res.data.data.length > 0) {
            res.data.data.forEach(item => {
              item.fold = true
            })
            this.options = res.data.data
          } else {
            this.options = []
          }


        } else {
          this.$message({type: "error", message: res.data.msg});
        }
        this.loading = false;
      }).catch((err) => {
      });
    },
    trainingCoursegetRemainingScore(outline_id) {
      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.trainingCoursegetRemainingScore, {
                data: {
                  outline_id
                }
              }).then((res) => {
        if (res.data.code == 0) {

          this.allocableCredits = Number(res.data.data) >= 0 ? res.data.data : 0


        } else {
          this.$message({type: "error", message: res.data.msg});
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      });

    },
    handleClose() {

      this.$refs['ruleForm1'].clearValidate()
      this.$refs['ruleForm2'].clearValidate()

      // this.dialogVisible = false

    },
    handleOk() {
      switch (this.activeName) {
        case 0:
          this.$refs['ruleForm1'].validate((valid) => {
            if (valid) {
              let url = this.ruleForm.id ? this.$baseUrl.trainingCourseVideoEdit : this.$baseUrl.trainingCourseVideoAdd
              let obj = {
                ...this.ruleForm,
              }
              obj.contents_id = obj.contents_id.length ? obj.contents_id.slice(-1)[0] : ''
              obj.file_name = this.fileList.length ? this.fileList[0].path : ''
              this.$tools
                  .asyncPost(
                      this,
                      url, {
                        data: obj
                      }).then((res) => {
                if (res.data.code == 0) {
                  // this.$message({ type: "success", message: '添加成功' });
                  if (!this.ruleForm.id) {
                    this.ruleForm.id = res.data.data.id
                  }

                  this.activeName = 1


                } else {
                  this.$message({type: "error", message: res.data.msg});
                }
              }).catch((err) => {
                // this.loading = false;
              });
            } else {
              console.log('error submit!!');
              return false;
            }
          });
          break;
        case 1:
          this.$refs['ruleForm2'].validate((valid) => {
            if (valid) {
              let url = this.$baseUrl.trainingCourseVideoEdit
              let obj = {...this.ruleForm,}
              obj.contents_id = obj.contents_id.length ? obj.contents_id.slice(-1)[0]  : ''
              console.log('contents_id',obj.contents_id)
              obj.file_name = this.fileList.length ? this.fileList[0].path : ''
              this.$tools
                  .asyncPost(
                      this,
                      url, {
                        data: obj
                      }).then((res) => {
                if (res.data.code == 0) {
                  this.$message({type: "success", message: '添加成功'});
                  this.$emit('ok')
                  this.dialogVisible = false


                } else {
                  this.$message({type: "error", message: res.data.msg});
                }
              }).catch((err) => {
                // this.loading = false;
              });
            } else {
              console.log('error submit!!');
              return false;
            }
          });
          break;
        default:
          break;
      }

    },
    cancel() {
      // 这里需要判断是新增还是编辑，只有在新增的时候并且保存过生成id了，就要调删除接口

      if (!this.edit && this.ruleForm.id) {

        this.$tools
            .asyncPost(
                this,
                this.$baseUrl.trainingCourseVideoDel, {
                  data: {
                    ids: [this.ruleForm.id]

                  }
                }).then((res) => {
          if (res.data.code == 0) {
            this.$refs['ruleForm1'].clearValidate()
            this.$refs['ruleForm2'].clearValidate()
            this.dialogVisible = false

          } else {
            this.$message({type: "error", message: res.data.msg});
          }

        }).catch((err) => {
        });

      } else {
        this.$refs['ruleForm1'].clearValidate()
        this.$refs['ruleForm2'].clearValidate()
        this.dialogVisible = false
      }


    },

    changeTab(value) {
      this.activeName = value;
      switch (value) {
        case '0':
          // this.$nextTick(() => {
          //     this.$refs.preview1.getData(this.left_list_value)
          // })
          break;

        default:
          break;
      }
      // if (value == 0) {
      //     this.path = '/data'
      //     this.cenjiclick('')
      //     this.bycodelist('DM-IMG-TPSCGS', 1)
      //     this.bycodelist('DM-VIDEO-SPSCGS', 2)
      // } else if (value == 1) {
      //     this.path = '/pic'
      //     this.fileslist()
      // } else {
      //     this.path = '/video'
      //     this.fileslist()
      // }
      // this.tableData = []
      // this.mydata.path = this.path
    },
    convertBase64ToFile(base64String, fileName) {
      const byteCharacters = atob(base64String.substring(base64String.indexOf(',') + 1));
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'image/jpg'});
      const file = new File([blob], fileName, {type: blob.type});
      return file;
    },
    // 上传前
    beforeUpload(file) {
      console.log(333);
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      const hasVideo = this.fileList.length
      if (!hasVideo) {
        this.$message({type: "error", message: "请先上传视频!"});
      }
      if (!isJPG) {
        this.$message({type: "error", message: "上传头像图片只能是 JPG 格式!"});
      }
      if (!isLt2M) {
        this.$message({type: "error", message: "上传头像图片大小不能超过 2MB!"});

      }

      if (hasVideo && isJPG && isLt2M) {
        this.cropperModel.val = true
        this.vuecropper_file = [{
          url: URL.createObjectURL(file),
        }];
      }
      return isJPG && isLt2M;
    },
    // 上传前
    beforeUpload1(file) {
      console.log(333);
      const isJPG = this.accept.includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message({type: "error", message: "上传的视频格式不对!"});
      }
      // if (!isLt2M) {
      //     this.$message({ type: "error", message: "上传头像图片大小不能超过 2MB!" });

      // }
      return isJPG;
    },
    // 上传
    uploadFn(file) {


      let newFile = this.convertBase64ToFile(file, this.ruleForm.id);
      var formdata = new FormData()
      formdata.append('file', newFile, this.ruleForm.id + '_cover.jpg');
      // formdata.append('filename',this.ruleForm.outline_id+'.jpg');
      formdata.append('rename', '0');
      //this.$baseUrl.filesupload + '/public/trainingCourse/' + localStorage.getItem('enterprise_id') + '/pic'
      //先测试使用
      this.$axios.post(this.$baseUrl.filesupload + '/public/' + localStorage.getItem('enterprise_id') + '/trainingCourse/pic', formdata,
          {
            headers: {
              'token': localStorage.getItem("token"),
              'content-type': 'multipart/form-data'
            }
          }
      ).then((res) => {
        if (res.data.code == 0) {
          this.ruleForm.cover = res.data.data[res.data.data.length - 1].upload_path;
          this.$forceUpdate()

        } else {
          this.$message({type: "error", message: res.data.msg})
        }

      })

    },
    // 上传
    uploadFn1({file}) {

      this.fileList = []


      var formdata = new FormData()
      formdata.append('file', file);
      formdata.append('rename', '1');
      //this.$baseUrl.filesupload + '/public/trainingCourse/' + localStorage.getItem('enterprise_id') + '/video'
      //先测试上传到临时位置
      this.$axios.post(this.$baseUrl.filesupload + '/' + localStorage.getItem('enterprise_id') + '/trainingCourse/video/' + this.ruleForm.id, formdata,
          {
            headers: {
              'token': localStorage.getItem("token"),
              'content-type': 'multipart/form-data'
            },
            // 新增上传进度监听
            onUploadProgress: (progressEvent) => {
              console.log(progressEvent);

              if (progressEvent.total) {
                this.progress = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
                this.showProgress = true; // 开始上传时显示进度条
              }
            }
          }
      ).then((res) => {
        if (res.data.code == 0) {
          // 上传成功后隐藏进度条
          this.showProgress = false;
          this.progress = 0;
          let data = res.data.data[res.data.data.length - 1];
          // if (data.filename.length > 50) {
          //     data.filename = data.filename.slice(0, 20) + '...' + data.filename.slice(data.filename.indexOf('.') - 20, data.filename.length);
          // }
          this.fileList = [{
            name: data.filename,
            path: data.upload_path
          }]
          if (this.fileList.length > 2) {
            this.fileList = this.fileList.slice(-3)
          }
          this.$forceUpdate()
        } else {
          // 上传失败也隐藏进度条
          this.showProgress = false;
          this.progress = 0;
          this.$message({type: "error", message: res.data.msg})
        }


      })

    },
    // 查看
    see(data) {
      this.activeName = 0
      this.disabled = true
      this.fileList = data.file_name ? [{
        path: data.file_name,
      }] : []
      this.ruleForm = data
      this.getOptions()
      this.trainingCoursegetRemainingScore(this.ruleForm.outline_id)
    },
    // 视频预览
    previewVideo(video) {
      this.$refs.previewVideo.dialogVisible = true;
      this.$refs.previewVideo.init(this.ruleForm, true);

    },
  }
}
</script>

<style lang="less" scoped>
.tc-main {
  height: 320px;
  margin: 0 auto;

  /deep/ .el-dialog__wrapper {
    overflow: visible;
  }
}

// tab样式
.tabs {
  // height: 40px;
  // border-bottom: 1px solid #e4e7ed;
  margin-top: 10px;
  box-sizing: border-box;
  background-color: #fff;

  .tabs__item {
    // width: 90px;
    height: 100%;
    line-height: 40px;
    padding: 0 20px;
    text-align: center;
    display: inline-block;
    box-sizing: border-box;
  }


  .tabs__item:hover {
    cursor: pointer;
  }


}

.box {
  display: flex;
  align-items: center;
}

.box2 {
  padding-top: 20px;

  // display: flex;
  // justify-content: space-between;
  .form2 {
    display: flex;
    justify-content: space-between;
  }
}

.videoList {
  display: flex;
  align-items: center;

  p {
    flex: 1;
    min-width: 0;
  }

  i {
    width: 20px;
  }
}

.courseImage {
  // height: 100%;

  .required {
    width: 25px;
    content: '*';
    color: #F56C6C;
    text-align: right;
    margin-right: 4px;
  }

  /deep/ .el-form-item__content {
    display: flex;
    margin-left: 0 !important;

    .courseImageUpload {
      height: 161px;
      // flex: 1;
      // min-width: 0;
      width: 226px;

      .el-upload.el-upload--text {
        width: 100%;
        height: calc(100% - 0px);
      }

      .avatar-uploader-icon {
        // font-size: 28px;
        color: #8c939d;
        // width: 100%;
        // height: 100%;
        line-height: 161px;
        text-align: center;
      }

      img {
        height: 100%;
        width: 100%;

        object-fit: cover;
      }
    }
  }
}

.video_box {
  width: 350px;
  // /deep/ .el-form-item__content {

  //     margin-left: 0 !important;


  // }
}

/* 新增进度条样式 */
.upload-progress {
  margin-top: 10px;
  width: 350px;
  /* 与视频上传区域宽度匹配 */
}
</style>